<template>
  <div class="openId">
    <div v-if="error">Error: {{ error }}</div>
  </div>
</template>

<script>
export default {
  name: 'OpenId',

  data() {
    return {
      error: '',
    };
  },

  computed: {
    urlHashValues() {
      const urlHash = this.$route.hash;
      const vars = {};
      const hashes = urlHash.slice(urlHash.indexOf('#') + 1).split('&');

      for (let i = 0; i < hashes.length; i += 1) {
        const hash = hashes[i].split('=');

        if (hash.length > 1) {
          vars[hash[0]] = hash[1];
        } else {
          vars[hash[0]] = null;
        }
      }

      return vars;
    },
  },

  mounted() {
    // send JWT

    const hasError = this.urlHashValues.error;
    if (hasError) {
      this.error = this.urlHashValues.error_description;
      return;
    }

    const JWT = this.urlHashValues.id_token;
    this.$store.dispatch('saveJWT', JWT);

    this.$store
      .dispatch('login', JWT)
      .then(() => {
        this.$store
          .dispatch('updateUserInfo')
          .then(() => {
            this.$router.push({ name: 'studyList', params: { state: this.urlHashValues.state } });
          })
          .catch(err => {
            this.error = err;
            setTimeout(() => {
              this.$router.push({ name: 'Logout' });
            }, 2000);
          });
      })
      .catch(err => {
        this.error = err.response ? ` ${JSON.stringify(err.response.statusText)}` : 'An error occured';
      });
  },
};
</script>
